
import React, {useRef, useState} from 'react';
import { Timeline } from 'primereact/timeline';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import run from "../../assets/img/milestone/run.svg";
import fotoPerijinan from "../../assets/img/milestone/foto-perijinan.png";
import mulaiBeroperasi from "../../assets/img/milestone/mulai-beroperasi.png";
import pendaftaranOjk from "../../assets/img/milestone/pendaftaran-ojk.png";
import pendirianAft from "../../assets/img/milestone/pendirian-aft.png";
import sertifikasi from "../../assets/img/milestone/sertifikasi-ISO.png";
import anugerahBumi from "../../assets/img/milestone/anugerah-bumi-feb-2023.png";
import cyberUniversity from "../../assets/img/milestone/cyber-university-feb-2023.png";
import developerMei from "../../assets/img/milestone/mei-2023.png";
import glints from "../../assets/img/milestone/april-2023.png";
import hiBank from "../../assets/img/milestone/nov-2023.png";
import jTrust from "../../assets/img/milestone/januari-2024.png";
import bankSaqu from "../../assets/img/milestone/bank-saqu-2024.png";
import btpn from "../../assets/img/milestone/btpn-2024.png";
import bankRaya from "../../assets/img/milestone/bank-raya-2024.png";
import jTrust25 from "../../assets/img/milestone/jtrust-2025.png";
import bankPerdana from "../../assets/img/milestone/bank-perdana-2024.png";
import leftRiv from "../../assets/img/icon/arrow-left.riv";
import rightRiv from "../../assets/img/icon/arrow-right.riv";
import Rive from "rive-react";

// **THIS IS TIMELINE REACT**
export default function TemplateDemo() {
    const elementRef = useRef(null);
    const [arrowDisable, setArrowDisable] = useState(true);

    const events = [
        {
            year: 'Sekarang',
            month: '',
            image: '',
            content: '',
        },
        {
            year: 'Sekarang',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Januari 2025',
            image: jTrust25,
            content: 'Kembali menjalin kerjasama channeling dengan PT Bank JTrust Indonesia Tbk (J Trust Bank) dalam memperluas akses pembiayaan bagi pelaku usaha mikro, khususnya melalui fasilitas kredit inovatif seperti pembiayaan inventory (inventory financing).'
        },
        {
            year: '2025',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Desember 2024',
            image: bankPerdana,
            content: 'Bekerjasama channeling dengan BANK PERDANA (PT BPR DAYA PERDANA NUSANTARA) untuk meningkatkan akses masyarakat kepada Kredit Multiguna (KMG), sehingga memungkinkan calon nasabah hanya perlu menggunakan smartphone untuk proses pengajuan pembiayaannya secara digital.'
        },
        {
            year: '',
            month: 'Agustus 2024',
            image: bankRaya,
            content: 'Bekerjasama channeling dengan Bank Raya (PT Bank Raya Indonesia Tbk) dalam meningkatkan akses pembiayaan sektor produktif bagi UMKM, sekaligus mendorong kontribusi industri perbankan dan fintech lending terhadap perekonomian nasional.'
        },
        {
            year: '',
            month: 'April 2024',
            image: bankSaqu,
            content: 'Bekerjasama channeling dengan Bank Saqu (PT Bank Jasa Jakarta) dalam meningkatkan akses pembiayaan sektor produktif bagi UMKM'
        },
        {
            year: '',
            month: 'Maret 2024',
            image: btpn,
            content: 'Bekerjasama channeling dengan Bank BTPN dalam meningkatkan akses pembiayaan sektor produktif bagi UMKM.'
        },
        {
            year: '',
            month: 'Januari 2024',
            image: jTrust,
            content: 'Bekerjasama channeling dengan PT Bank JTrust Indonesia Tbk dalam meningkatkan akses pembiayaan sektor produktif bagi UMKM.'
        },
        {
            year: '2024',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'November 2023',
            image: hiBank,
            content: 'Bekerjasama channeling dengan PT Bank Hibank Indonesia dalam meningkatkan akses pembiayaan sektor produktif bagi UMKM.'
        },
        {
            year: '',
            month: 'Mei 2023',
            image: developerMei,
            content: 'Bekerjasama dan mendukung pertumbuhan UMKM dalam memberikan pembiayaan Micro Developer Financing untuk unit perumahan Parama Residence dan Foresta di Parung, Bogor, Jawa Barat.'
        },
        {
            year: '',
            month: 'April 2023',
            image: glints,
            content: 'Menjadi Salah Satu Rekomendasi Aplikasi P2P Lending Terbaik dan Tepercaya di Indonesia versi Glints'
        },
        {
            year: '',
            month: 'Februari 2023',
            image: anugerahBumi,
            content: 'Berkolaborasi dengan PT Anugerah Bumi Seloliman dalam melakukan pemasaran/marketing produk pinjaman EBP (Employee Benefit Program).'
        },
        {
            year: '',
            month: 'Februari 2023',
            image: cyberUniversity,
            content: 'Berkolaborasi dengan institusi pendidikan Cyber University untuk mendukung dan memajukan pendidikan di Indonesia. Penyaluran program pemagangan, pengembangan produk dan pengayaan untuk penelitian di bidang industri fintech di lingkungan universitas.'
        },
        {
            year: '2023',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Agustus 2021',
            image: fotoPerijinan,
            content: '19 Agustus 2021, dinyatakan berizin dan diawasi OJK sesuai dengan surat keputusan nomor KEP-76/D.05/2021 tentang Pemberian Izin Usaha Perusahaan Penyelenggara LPMUBTI.'
        },
        {
            year: '2021',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'September 2019',
            image: sertifikasi,
            content: 'Memperoleh Sertifikasi ISO27001:2013 dalam hal Standarisasi Manajemen Keamanan Informasi.'
        },
        {
            year: '2019',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'November 2018',
            image: mulaiBeroperasi,
            content: 'Mulai beroperasi sebagai Lembaga Jasa Keuangan - Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi (LPMUBTI)'
        },
        {
            year: '',
            month: 'Oktober 2018',
            image: pendaftaranOjk,
            content: '16 Oktober 2018 terdaftar pada Otoritas Jasa Keuangan melalui surat nomor S-960/NB.213/2018'
        },
        {
            year: '',
            month: 'April 2018',
            image: pendirianAft,
            content: 'PT Adiwisista Finansial Teknologi didirikan di Jakarta'
        },
        {
            year: '2018',
            month: '',
            image: '',
            content: '',
        },
    ];

    const customizedMarker = (item, index) => {
        return (
            <div>
                {index === 0 && item.year !== '' ?
                    <img width='300px' src={run} alt='runImage'/>
                    : item.year !== '' ?
                        <Card className="yearCard">
                            <h5>{item.year}</h5>
                        </Card>
                        : item.month === '' ?
                            <div/>
                            : <div className="bullet"/>
                }
            </div>
        );
    };

    const customizedContent = (item, index) => {
        return (
            <div>
                {item.month !== '' ?
                    <Card className="contentCard">
                        <img src={item.image} alt='milestoneCardImage'/>
                        <p><span className="p-card-title">{item.month}</span><br/>{item.content}</p>
                    </Card>
                    : item.year !== '' ?
                        index === 0 ?
                            <div style={{width: 200}}/>
                            : <div style={{width: 300}}/> : <div/>
                }
            </div>
        );
    };

    const handleHorizantalScroll = (element, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            element.scrollLeft += step;
            scrollAmount += Math.abs(step);
            if (scrollAmount >= distance) {
                clearInterval(slideTimer);
            }

            if (element.scrollLeft === 0) {
                setArrowDisable(true);
            } else {
                setArrowDisable(false);
            }
        }, speed);
    };

    return (
        <div className="container-3">
            <div className="section-title">
                <h2 className="text-header">Peristiwa Penting</h2>
                <div className="explanation">
                    <p>Ikuti perjalanan kami yang membanggakan dari konsep awal hingga berhasil meraih pencapaian kami
                        hari ini, menelusuri setiap milestone penting yang telah membentuk identitas dan reputasi kami
                        dalam memberikan pelayanan terbaik sebagai solusi keuangan Anda.</p>
                </div>
                <div className="arrow-button-mobile">
                    <Button rounded icon="pi pi-arrow-left"
                            onClick={() => {
                                handleHorizantalScroll(elementRef.current, 20, 800, -300);
                            }}
                            disabled={arrowDisable}/>
                    <Button rounded icon="pi pi-arrow-right"
                            onClick={() => {
                                handleHorizantalScroll(elementRef.current, 20, 1000, 300);
                            }}/>
                </div>
            </div>
            <div className="milestone-container">
                <div className="arrow-button">
                    <div className='button-shadow'>
                        <Button rounded
                                onClick={() => {
                                    handleHorizantalScroll(elementRef.current, 20, 800, -300);
                                }}
                                disabled={arrowDisable}>
                            <Rive
                                src={leftRiv}
                                className="rive-button"
                            />
                        </Button>
                    </div>
                    <div className='button-shadow'>
                        <Button rounded
                                onClick={() => {
                                    handleHorizantalScroll(elementRef.current, 20, 1000, 300);
                                }}>
                            <Rive
                                src={rightRiv}
                                className="rive-button"
                            />
                        </Button>
                    </div>
                </div>
                <div className="timelineCard" ref={elementRef}>
                    <Timeline value={events} layout="horizontal" align="alternate" className="customized-timeline"
                              content={customizedContent} marker={customizedMarker}/>
                </div>
            </div>
        </div>
    )
}